export default "__VITE_ASSET__XTRf5nx___"